module.exports = __webpack_public_path__ + "static/img/mediamodifier_image_2.f3477ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mediamodifier_image_2.png
// module id = b96o
// module chunks = 0